export const weekStartsOnOptions = [
    {
        label: 'Monday',
        value: 1
    },
    {
        label: 'Tuesday',
        value: 2
    },
    {
        label: 'Wednesday',
        value: 3
    },
    {
        label: 'Thursday',
        value: 4
    },
    {
        label: 'Friday',
        value: 5
    },
    {
        label: 'Saturday',
        value: 6
    },
    {
        label: 'Sunday',
        value: 0
    }
];

export const yearStartsOnMonthOptions: {
    label: string;
    value: number;
    /** How many days are in the month */
    days: number;
}[] = [
    {
        label: 'January',
        value: 0,
        days: 31
    },
    {
        label: 'February',
        value: 1,
        days: 28
    },
    {
        label: 'March',
        value: 2,
        days: 31
    },
    {
        label: 'April',
        value: 3,
        days: 30
    },
    {
        label: 'May',
        value: 4,
        days: 31
    },
    {
        label: 'June',
        value: 5,
        days: 30
    },
    {
        label: 'July',
        value: 6,
        days: 31
    },
    {
        label: 'August',
        value: 7,
        days: 31
    },
    {
        label: 'September',
        value: 8,
        days: 30
    },
    {
        label: 'October',
        value: 9,
        days: 31
    },
    {
        label: 'November',
        value: 10,
        days: 30
    },
    {
        label: 'December',
        value: 11,
        days: 31
    }
];
